export type ResponsiveCSSValue< T > = Array< T | undefined > | T;
